// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"style_breadcrumbs__yhvxq","current":"style_current__uZDyU","arrow":"style_arrow__aQThc"};